module.exports = __webpack_public_path__ + "static/media/customLand-coverDetails.4333c613.svg";